var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-end mb-3"},[_c('v-card',{staticClass:"user-bubble",attrs:{"dark":"","color":"primary","elevation":"0"}},[_c('v-card-text',{staticClass:"py-2 px-3"},[_vm._v(_vm._s(_vm.text))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }